//= Functions & Modules
// Others
import { boundMethod } from 'autobind-decorator';
import React from 'react';

//= Structures & Data
// Own
import { ShowConnectDialogEventName } from '../data/ShowConnectDialogEventName';
import { ConnectStatusChangedEventName } from '../data/ConnectStatusChangedEventName';

type State = {
    connected: boolean;
};

export class ConnectionStatus extends React.PureComponent<{}, State> {
    constructor(props: {}) {
        super(props);

        this.state = {
            connected: false,
        };
    }

    componentDidMount() {
        window.addEventListener(ConnectStatusChangedEventName, this.onConnectStatusChanged.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener(ConnectStatusChangedEventName, this.onConnectStatusChanged.bind(this));
    }

    @boundMethod
    onConnectStatusChanged(event: CustomEvent) {
        this.setState({ connected: event.detail });
    }

    @boundMethod
    showConnectDialog() {
        window.dispatchEvent(new CustomEvent(ShowConnectDialogEventName));
    }

    render() {
        const { connected } = this.state;
        return (
            <button
                className="flex items-center gap-1.5 text-xs cursor-pointer transition-colors hover:text-title text-unselected1 px-2 py-1 rounded-lg hover:bg-white/[0.05]"
                onClick={this.showConnectDialog}
            >
                <span
                    className={`inline-block rounded-full w-2 h-2 flex-shrink-0 ${
                        connected ? 'bg-success animate-pulse' : 'bg-danger'
                    }`}
                />
                <span>{connected ? 'Connected' : 'Not connected'}</span>
            </button>
        );
    }
}
